module.exports = __webpack_public_path__ + "static/img1-98d97051a2e73054abfdd70cd7cf4882.png";